module.exports = __webpack_public_path__ + "img/formula.70b4b885.png";